import { isAlpha, isEmail, isFloat, isEmpty } from 'validator';
import { PhoneNumber } from '@tools/phoneNumber';

export class TwigFormRules {
  static required = (value) => value && !isEmpty(value.trim());

  static float = (value) => isFloat(value, { min: 0 });

  static price = (value) => isEmpty(value) || (isFloat(value, { min: 0 }) && Math.round(Math.abs(value) * 100) / 100 === parseFloat(value));

  static email = (value) => isEmail(value);

  static alpha = (value) => isAlpha(value);

  static noNumbers = (value) => /^([^0-9]*)$/.test(value);

  static phone = (value) => new PhoneNumber(value).isValid;

  static noDefaultValue = (value) => value !== '0';

  static schedule = (value) => /^[01][0-9]:[0134][05]$/.test(value);
}
